import React from 'react';
import ReactDOM from 'react-dom';
import {LoginRoot} from 'app/components/Root/login';
import {DriftComTracker} from 'app/util/DriftComTracker/DriftComTracker';

document.addEventListener('DOMContentLoaded', () => {
  DriftComTracker.useInLogin();
  ReactDOM.render(React.createElement(LoginRoot), document.querySelector('#app'));
});
